import React, { useEffect } from 'react';

import { FontSize } from '../../../typings/design-tokens';
import { Role } from '../../../typings/player';
import { PlayerCharts, PlayerStatistic } from '../../../typings/player-statistics';
import { makeClassNames } from '../../../utils/styles';
import Text from '../../atoms/text/text';
import DropdownMenu from '../../organisms/dropdown-menu/dropdown-menu';
import { IMenuList } from '../../molecules';

import { buildStats } from './player-statistics-helpers';

import './player-statistics.scss';

const SUBTITLE_FONT_SIZE: FontSize = '18';

export interface IPlayerStatistics {
  playerId: string; // Passed from BE
  playerRole: Role;
  items: (PlayerStatistic | PlayerCharts)[];
  subtitle: string;
  dropdown?: IMenuList;
}

const classNames = (playerRole: Role) =>
  makeClassNames({
    divider: 'player-statistics__divider',
    grid: ['player-statistics__grid', `player-statistics__role--${playerRole.toLowerCase()}`],
    stat: 'player-statistics__stats-wrapper__stat',
    statsWrapper: 'player-statistics__stats-wrapper',
    subtitleWrapper: 'player-statistics__subtitle-wrapper',
    wrapper: 'player-statistics__wrapper',
  });

const PlayerStatistics = ({ items, subtitle, dropdown, playerRole }: IPlayerStatistics) => {
  const cn = classNames(playerRole);

  useEffect(() => {
    const loadedEvent = new CustomEvent('player_page_statistic_loaded');
    window.dispatchEvent(loadedEvent);
  }, []);

  return (
    <div className={cn.wrapper}>
      <div className={cn.subtitleWrapper}>
        <Text color="blue" fontSize={SUBTITLE_FONT_SIZE} fontWeight="500">
          {subtitle}
        </Text>
        {dropdown && (
          <div>
            <DropdownMenu {...dropdown} analyticsDataAttribute="dropdown-playerpages" />
          </div>
        )}
      </div>
      <div className={cn.divider} />
      <div className={cn.grid}>{buildStats(items, cn)}</div>
    </div>
  );
};

export default PlayerStatistics;
